import { fetchNewJwtToken, setToken } from '../../../utils/auth';

let isRefreshing = false;
let pendingRequests = [];
const resolvePendingRequests = () => {
  pendingRequests.map(callback => callback());
  pendingRequests = [];
  isRefreshing = false;
};

export const refreshTokenSynchronized = async client => {
  if (isRefreshing) {
    return new Promise(resolve => {
      pendingRequests.push(() => resolve());
    });
  }

  isRefreshing = true;
  const token = await fetchNewJwtToken();

  if (token) {
    setToken(token);
    resolvePendingRequests();

    return;
  }

  localStorage.clear();
  client.stop();
  client.cache.reset();
  client.clearStore().then(() => {
    client.resetStore();
  });
  resolvePendingRequests();
};
